import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { insightsApi } from '../infrastructure/api';
import { audienceKeys } from './audience';

export const insightsKeys = {
  lesson: (lessonId: string, days: number) => [...audienceKeys.all, 'insights', lessonId, days] as const,
};

/**
 * Insights da aula no período. Trocar o período mantém o gráfico anterior
 * na tela até o novo chegar — sem piscar esqueleto.
 */
export function useLessonInsights(lessonId: string, days: number) {
  return useQuery({
    queryKey: insightsKeys.lesson(lessonId, days),
    queryFn: () => insightsApi.lesson(lessonId, days),
    placeholderData: keepPreviousData,
    refetchInterval: 60_000,
  });
}
